var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKccMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "204px",
    height: "203px",
    viewBox: "0 0 204 203",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Screen Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "KIS-Kiosk-Admin-Login-Page---Mockup",
    transform: "translate(-222.000000, -225.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Screen-Icon",
    transform: "translate(222.500000, 225.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    fill: "#FFFFFF",
    x: 0.21,
    y: 0.29,
    width: 202,
    height: 202,
    rx: 101
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.062992,136 L41.9370079,136 C40.8716535,136 40,135.122843 40,134.050761 L40,41.9492386 C40,40.8771574 40.8716535,40 41.9370079,40 L161.062992,40 C162.128346,40 163,40.8771574 163,41.9492386 L163,134.050761 C163,135.122843 162.128346,136 161.062992,136 Z M43.8740157,132.101523 L159.125984,132.101523 L159.125984,43.8984772 L43.8740157,43.8984772 L43.8740157,132.101523 Z",
    id: "Shape",
    fill: "#F36E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.030418,113 L50.9695817,113 C50.3878327,113 50,112.613707 50,112.034268 L50,51.9657321 C50,51.3862928 50.3878327,51 50.9695817,51 L151.030418,51 C151.612167,51 152,51.3862928 152,51.9657321 L152,112.034268 C152,112.517134 151.515209,113 151.030418,113 Z M51.9391635,111.068536 L150.060837,111.068536 L150.060837,52.9314642 L51.9391635,52.9314642 L51.9391635,111.068536 Z",
    id: "Shape",
    fill: "#F36E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.052805,163 L73.9471947,163 C72.8762376,163 72,162.113636 72,161.030303 L72,151.969697 C72,150.886364 72.8762376,150 73.9471947,150 L129.052805,150 C130.123762,150 131,150.886364 131,151.969697 L131,161.030303 C131,162.113636 130.123762,163 129.052805,163 L129.052805,163 Z M75.8943894,159.060606 L127.105611,159.060606 L127.105611,153.939394 L75.8943894,153.939394 L75.8943894,159.060606 Z",
    id: "Shape",
    fill: "#F36E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.199453,154 L85.9516171,154 C85.3765036,154 84.80139,153.703863 84.417981,153.2103 C84.034572,152.716738 83.9387197,152.124464 84.034572,151.532189 L88.8271848,132.480687 C89.0188893,131.592275 89.7857074,131 90.6483777,131 L112.310988,131 C113.173658,131 113.940476,131.592275 114.132181,132.480687 L118.924793,151.532189 C119.116498,152.124464 118.924793,152.716738 118.541384,153.2103 C118.34968,153.703863 117.774566,154 117.199453,154 Z M88.4437758,150.051502 L114.707294,150.051502 L110.873204,134.948498 L92.1820138,134.948498 L88.4437758,150.051502 L88.4437758,150.051502 Z",
    id: "Shape",
    fill: "#F36E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,106 C66.4,106 66,105.609375 66,105.023438 L66,81.9765625 C66,81.390625 66.4,81 67,81 C67.6,81 68,81.390625 68,81.9765625 L68,104.925781 C68,105.511719 67.5,106 67,106 Z",
    id: "Path",
    fill: "#F36E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,106 C84.4,106 84,105.615385 84,105.038462 L84,76.9615385 C84,76.3846154 84.4,76 85,76 C85.6,76 86,76.3846154 86,76.9615385 L86,105.038462 C86,105.519231 85.5,106 85,106 Z",
    id: "Path",
    fill: "#F36E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,106 C101.4,106 101,105.609375 101,105.023438 L101,81.9765625 C101,81.390625 101.4,81 102,81 C102.6,81 103,81.390625 103,81.9765625 L103,104.925781 C103,105.511719 102.6,106 102,106 Z",
    id: "Path",
    fill: "#F36E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,106 C118.4,106 118,105.619048 118,105.047619 L118,92.952381 C118,92.3809524 118.4,92 119,92 C119.6,92 120,92.3809524 120,92.952381 L120,105.047619 C120,105.52381 119.6,106 119,106 Z",
    id: "Path",
    fill: "#F36E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,106 C135.4,106 135,105.609375 135,105.023438 L135,81.9765625 C135,81.390625 135.4,81 136,81 C136.6,81 137,81.390625 137,81.9765625 L137,104.925781 C137,105.511719 136.6,106 136,106 Z",
    id: "Path",
    fill: "#F36E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.819238,81 C118.625562,81 118.528724,81 118.335048,80.9017544 L84.3449543,62.0385965 L66.3331096,70.7824561 C65.8489202,70.9789474 65.267893,70.7824561 65.0742172,70.2912281 C64.8805415,69.8 65.0742172,69.2105263 65.5584066,69.0140351 L83.9576028,60.0736842 C84.2481164,59.9754386 84.5386301,59.9754386 84.8291437,60.0736842 L118.7224,78.8385965 L135.475352,66.9508772 C135.959542,66.6561404 136.540569,66.754386 136.831082,67.1473684 C137.121596,67.6385965 137.024758,68.2280702 136.637407,68.522807 L119.400265,80.8035088 C119.206589,81 119.012914,81 118.819238,81 L118.819238,81 Z",
    id: "Path",
    fill: "#F36E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,127 C130.244898,127 128,124.755102 128,122 C128,119.244898 130.244898,117 133,117 C135.755102,117 138,119.244898 138,122 C138,124.755102 135.755102,127 133,127 Z M133,119.142857 C131.367347,119.142857 130.040816,120.469388 130.040816,122.102041 C130.040816,123.734694 131.367347,125.061224 133,125.061224 C134.632653,125.061224 135.959184,123.734694 135.959184,122.102041 C135.959184,120.469388 134.632653,119.142857 133,119.142857 Z",
    id: "Shape",
    fill: "#F36E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,127 C143.244898,127 141,124.755102 141,122 C141,119.244898 143.244898,117 146,117 C148.755102,117 151,119.244898 151,122 C151,124.755102 148.755102,127 146,127 Z M146,119.142857 C144.367347,119.142857 143.040816,120.469388 143.040816,122.102041 C143.040816,123.734694 144.367347,125.061224 146,125.061224 C147.632653,125.061224 148.959184,123.734694 148.959184,122.102041 C148.857143,120.469388 147.632653,119.142857 146,119.142857 Z",
    id: "Shape",
    fill: "#F36E2F"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKccMonitor);
export default __webpack_public_path__ + "static/media/kcc-monitor.d19c4ec7c64e6bffaab15d25bfb0b5a1.svg";
export { ForwardRef as ReactComponent };